var map = {
	"../pages/discount-list/discount-list.module": [
		631,
		32
	],
	"../pages/login-qr/login-qr.module": [
		632,
		31
	],
	"../pages/login-sync-platform-register/login-sync-platform-register.module": [
		300
	],
	"../pages/login-sync-platform/login-sync-platform.module": [
		301
	],
	"../pages/login/login.module": [
		303
	],
	"../pages/manaul-shopper/manaul-shopper.module": [
		302
	],
	"../pages/manaul/manaul.module": [
		305
	],
	"../pages/manual-merchant/manual-merchant.module": [
		304
	],
	"../pages/merchant-cashflow/merchant-cashflow.module": [
		306
	],
	"../pages/merchant-home/merchant-home.module": [
		314
	],
	"../pages/merchant-mission/merchant-mission.module": [
		307
	],
	"../pages/merchant-overview-cash/merchant-overview-cash.module": [
		308
	],
	"../pages/merchant-overview-movement/merchant-overview-movement.module": [
		309
	],
	"../pages/merchant-overview-plaza/merchant-overview-plaza.module": [
		310
	],
	"../pages/merchant-overview-plazamap/merchant-overview-plazamap.module": [
		311
	],
	"../pages/merchant-overview-stock/merchant-overview-stock.module": [
		312
	],
	"../pages/merchant-overview/merchant-overview.module": [
		313
	],
	"../pages/merchant-profit/merchant-profit.module": [
		315
	],
	"../pages/merchant-rental-rent-comfirm/merchant-rental-rent-comfirm.module": [
		316
	],
	"../pages/merchant-rental-rent-input/merchant-rental-rent-input.module": [
		633,
		30
	],
	"../pages/merchant-rental-rent/merchant-rental-rent.module": [
		320
	],
	"../pages/merchant-rental-yourspace/merchant-rental-yourspace.module": [
		317
	],
	"../pages/merchant-rental/merchant-rental.module": [
		321
	],
	"../pages/merchant-result/merchant-result.module": [
		319
	],
	"../pages/merchant-select-team/merchant-select-team.module": [
		318
	],
	"../pages/merchant-shop-menu/merchant-shop-menu.module": [
		324
	],
	"../pages/merchant-shop-pay-rental-confirm/merchant-shop-pay-rental-confirm.module": [
		322
	],
	"../pages/merchant-shop-pay-rental-input/merchant-shop-pay-rental-input.module": [
		634,
		29
	],
	"../pages/merchant-shop-pay-rental/merchant-shop-pay-rental.module": [
		323
	],
	"../pages/merchant-shop-refill-stock/merchant-shop-refill-stock.module": [
		326
	],
	"../pages/merchant-stat-mission/merchant-stat-mission.module": [
		635,
		28
	],
	"../pages/merchant-stat-shop/merchant-stat-shop.module": [
		636,
		27
	],
	"../pages/merchant-stat-shopper/merchant-stat-shopper.module": [
		659,
		26
	],
	"../pages/merchant-your-shop/merchant-your-shop.module": [
		325
	],
	"../pages/plaza-cashflow/plaza-cashflow.module": [
		328
	],
	"../pages/plaza-collect-fee-confirm/plaza-collect-fee-confirm.module": [
		637,
		25
	],
	"../pages/plaza-collect-fee/plaza-collect-fee.module": [
		327
	],
	"../pages/plaza-mission/plaza-mission.module": [
		329
	],
	"../pages/plaza-overview-cash/plaza-overview-cash.module": [
		330
	],
	"../pages/plaza-overview-movement/plaza-overview-movement.module": [
		333
	],
	"../pages/plaza-overview-plazamap/plaza-overview-plazamap.module": [
		334
	],
	"../pages/plaza-overview/plaza-overview.module": [
		331
	],
	"../pages/plaza-profit/plaza-profit.module": [
		332
	],
	"../pages/plaza-result/plaza-result.module": [
		377
	],
	"../pages/plaza-scan-pay/plaza-scan-pay.module": [
		336
	],
	"../pages/plaza-select-plan-choose/plaza-select-plan-choose.module": [
		335
	],
	"../pages/plaza-select-plan-invest/plaza-select-plan-invest.module": [
		638,
		24
	],
	"../pages/plaza-select-plan-rent/plaza-select-plan-rent.module": [
		660,
		23
	],
	"../pages/plaza-select-plan/plaza-select-plan.module": [
		338
	],
	"../pages/plaza-select-team/plaza-select-team.module": [
		339
	],
	"../pages/plaza-select-theme-save/plaza-select-theme-save.module": [
		337
	],
	"../pages/plaza-select-theme/plaza-select-theme.module": [
		340
	],
	"../pages/plaza-slot-theme/plaza-slot-theme.module": [
		639,
		22
	],
	"../pages/plaza-stat-merchant/plaza-stat-merchant.module": [
		663,
		21
	],
	"../pages/plaza-stat-mission/plaza-stat-mission.module": [
		640,
		20
	],
	"../pages/plaza-stat-shopper/plaza-stat-shopper.module": [
		642,
		19
	],
	"../pages/plaza-stat-sub/plaza-stat-sub.module": [
		641,
		18
	],
	"../pages/plaza-stat/plaza-stat.module": [
		643,
		17
	],
	"../pages/plaza-theme-change-save/plaza-theme-change-save.module": [
		341
	],
	"../pages/plaza-theme-change/plaza-theme-change.module": [
		344
	],
	"../pages/plaza-ticket-social/plaza-ticket-social.module": [
		342
	],
	"../pages/plaza-ticket/plaza-ticket.module": [
		343
	],
	"../pages/qrresult/qrresult.module": [
		645,
		16
	],
	"../pages/quiz-result/quiz-result.module": [
		644,
		15
	],
	"../pages/quiz-test/quiz-test.module": [
		661,
		14
	],
	"../pages/quiz/quiz.module": [
		646,
		13
	],
	"../pages/scanqr/scanqr.module": [
		647,
		1
	],
	"../pages/select-language/select-language.module": [
		648,
		12
	],
	"../pages/shopper-buy-product-merchantlist/shopper-buy-product-merchantlist.module": [
		649,
		0
	],
	"../pages/shopper-buy-product-pay-input/shopper-buy-product-pay-input.module": [
		650,
		11
	],
	"../pages/shopper-buy-product-pay-scan/shopper-buy-product-pay-scan.module": [
		346
	],
	"../pages/shopper-buy-product-pay-scan_confirm/shopper-buy-product-pay-scan_confirm.module": [
		345
	],
	"../pages/shopper-buy-product-pay/shopper-buy-product-pay.module": [
		348
	],
	"../pages/shopper-buy-product-plazalist/shopper-buy-product-plazalist.module": [
		347
	],
	"../pages/shopper-buy-product/shopper-buy-product.module": [
		662,
		10
	],
	"../pages/shopper-buy-social-pay-input/shopper-buy-social-pay-input.module": [
		651,
		9
	],
	"../pages/shopper-buy-social-pay-scan-confirm/shopper-buy-social-pay-scan-confirm.module": [
		349
	],
	"../pages/shopper-buy-social-pay-scan/shopper-buy-social-pay-scan.module": [
		350
	],
	"../pages/shopper-buy-social-pay/shopper-buy-social-pay.module": [
		351
	],
	"../pages/shopper-buy-social-plazalist/shopper-buy-social-plazalist.module": [
		353
	],
	"../pages/shopper-buy-social/shopper-buy-social.module": [
		352
	],
	"../pages/shopper-home/shopper-home.module": [
		375
	],
	"../pages/shopper-mission-outstanding/shopper-mission-outstanding.module": [
		354
	],
	"../pages/shopper-mission-shopping/shopper-mission-shopping.module": [
		355
	],
	"../pages/shopper-mission-social-desc/shopper-mission-social-desc.module": [
		376
	],
	"../pages/shopper-mission-social/shopper-mission-social.module": [
		360
	],
	"../pages/shopper-mission/shopper-mission.module": [
		365
	],
	"../pages/shopper-overview-cash/shopper-overview-cash.module": [
		356
	],
	"../pages/shopper-overview-movement/shopper-overview-movement.module": [
		357
	],
	"../pages/shopper-overview-plaza/shopper-overview-plaza.module": [
		358
	],
	"../pages/shopper-overview-plazamap/shopper-overview-plazamap.module": [
		361
	],
	"../pages/shopper-overview/shopper-overview.module": [
		359
	],
	"../pages/shopper-requrement/shopper-requrement.module": [
		652,
		8
	],
	"../pages/shopper-result/shopper-result.module": [
		653,
		7
	],
	"../pages/shopper-select-team/shopper-select-team.module": [
		363
	],
	"../pages/shopper-shopping-bag/shopper-shopping-bag.module": [
		362
	],
	"../pages/shopper-social-group-create-shop-new/shopper-social-group-create-shop-new.module": [
		366
	],
	"../pages/shopper-social-group-create-shop/shopper-social-group-create-shop.module": [
		364
	],
	"../pages/shopper-social-group-create/shopper-social-group-create.module": [
		367
	],
	"../pages/shopper-social-group-join-input/shopper-social-group-join-input.module": [
		654,
		6
	],
	"../pages/shopper-social-group-join-scan-confirm/shopper-social-group-join-scan-confirm.module": [
		368
	],
	"../pages/shopper-social-group-join-scan/shopper-social-group-join-scan.module": [
		369
	],
	"../pages/shopper-social-group-join/shopper-social-group-join.module": [
		371
	],
	"../pages/shopper-social-group/shopper-social-group.module": [
		372
	],
	"../pages/shopper-vote-plaza/shopper-vote-plaza.module": [
		370
	],
	"../pages/shopper-vote/shopper-vote.module": [
		374
	],
	"../pages/video-tutorial-modal/video-tutorial-modal.module": [
		373
	],
	"../pages/view-header/view-header.module": [
		656,
		5
	],
	"../pages/view-header2/view-header2.module": [
		657,
		4
	],
	"../pages/wait-step2/wait-step2.module": [
		655,
		3
	],
	"../pages/wait-step3/wait-step3.module": [
		658,
		2
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 250;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src lazy
// module id = 250
// module chunks = 33